import * as overlayActions from './actions'
import {store} from "../../reducers"

export const showOverlay = (message) => {
	store.dispatch(overlayActions.showOverlay(message));
};

export const hideOverlay = (message) => {
	store.dispatch(overlayActions.hideOverlay());
};


// WEBPACK FOOTER //
// ./src/api/overlay/index.js